import { getDriverDutyLogsRoutine, clearDriverDutyLogsRoutine } from 'actions';

const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, total_count: 0 } }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case getDriverDutyLogsRoutine.SUCCESS: {
      const { driver_duty_logs = [], pagination = { limit: 25, offset: 0, total_count: 0 } } = action.payload || {};
      return {
        ...state,
        all: {
          data: [...state.all.data, ...driver_duty_logs],
          pagination: { ...pagination }
        }
      };
    }
    case clearDriverDutyLogsRoutine.SUCCESS: {
      return {
        ...state,
        all: { data: [], pagination: { limit: 25, offset: 0, total_count: 0 } }
      };
    }
    default:
      return state;
  }
};

export default reducer;